export const HISTORY_PRICES_CONCEALED_STATE = 'TX';

export const ADVERTISED_PRICE_SOURCE = {
  DEALER_MSRP: 'dealerMsrp',
  DEALER_MSRP_FEES_INCLUDED: 'dealerMsrpFeesIncluded',
  INTERNET_PRICE: 'internetPrice',
};

export const DEALER_FEE_CONFIGURATIONS = {
  HAS_FEES: 'HAS_FEES',
  NO_FEES: 'NO_FEES',
  UNKNOWN: 'UNKNOWN',
};

export const DEALER_PRICE_DISCLAIMER = 'Does not include taxes, registration or other government fees.';
